import axios from 'axios';

const isLocalhost = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').trim()
  || (isLocalhost ? 'http://localhost:4002' : `${window.location.origin}/api`);

const api = axios.create({ baseURL: BACKEND_URL });

function resolveBackendAssetUrl(value) {
  if (!value || !String(value).startsWith('/catalog/')) return value || null;
  return `${BACKEND_URL.replace(/\/$/, '')}${value}`;
}

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('accessToken');
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { BACKEND_URL, resolveBackendAssetUrl };
export default api;
